import { useTranslation } from '@thoughtspot/i18n';
import { Link } from '@thoughtspot/radiant-react/widgets/link';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { isAdminRoutingEnabled } from '@thoughtspot/session-service';
import React, { useState } from 'react';
import { SettingHeaderComponent } from './setting/setting-header';
import { SettingSeperator } from './setting-seperator';
import styles from './settings-sage-link.module.scss';
const learnMore = { text: '', url: '', newWindow: false };
function getAdminUserManagementHref() {
    if (!isAdminRoutingEnabled())
        return '#/admin';
    return '#/admin/user-management';
}
export function ThoughtspotSageLinks({ onClickDisableWorksheets, }) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [isDisablingInProgress, setIsDisablingInProgress] = useState(false);
    return (React.createElement("div", { className: styles.sageLinksSectionContainer },
        showModal && (React.createElement(Modal, { isOpen: showModal, title: t('admin.sage.disableAllWorksheets'), size: ModalSize.SMALL, confirmButton: {
                text: t('adminSection.sage.worksheetDisablePrimaryButton'),
                isLoading: isDisablingInProgress,
                onConfirm: async () => {
                    setIsDisablingInProgress(true);
                    await onClickDisableWorksheets();
                    setShowModal(false);
                    setIsDisablingInProgress(false);
                },
            }, denyButton: {
                text: t('Cancel'),
                onDeny: () => setShowModal(false),
            } },
            React.createElement("ul", null,
                React.createElement("li", null, t('admin.sage.sageDisable.bodyOne')),
                React.createElement("li", null, t('admin.sage.sageDisable.bodyTwo'))))),
        React.createElement(SettingSeperator, null),
        React.createElement("div", { className: styles.sageSectionContainer },
            React.createElement(SettingHeaderComponent, { settingName: t('dataModelling.admin.page.title'), settingSubTitle: "", learnMore: learnMore, actions: [
                    {
                        title: t('admin.sage.disableAllWorksheets'),
                        type: 'DISABLE',
                    },
                ], actionHandler: () => setShowModal(true), titleSize: "medium" }),
            t('admin.sage.enableSpecficWorksheets.hyperLinkPreText'),
            ' ',
            React.createElement(Link, { href: "#/data", target: "_blank" }, t('CLICK')),
            ' ',
            t('admin.sage.enableSpecficWorksheets.hyperLinkPostText')),
        React.createElement(SettingSeperator, null),
        React.createElement("div", { className: styles.sageSectionContainer },
            React.createElement(SettingHeaderComponent, { settingName: t('USER_PRIVILEGES'), settingSubTitle: t('adminSection.sage.userManagement.subHeader'), learnMore: learnMore, actions: [], titleSize: "medium" }),
            t('admin.sage.userManagement.hyperLink'),
            React.createElement(Link, { href: getAdminUserManagementHref(), target: "_blank" }, t('CLICK_HERE')))));
}
//# sourceMappingURL=settings-sage-links.js.map